import { stripeFgColor } from './StripeStore';

export const updateStripeFgColor = (value) => stripeFgColor.update(oldValue => value);
